/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * This type is submitted by the client when the ELObox mounted on a vehicle detects an ELOshield zone violation between itself and a stationary unit.
 * @export
 * @interface StationaryUnitZoneViolationEventCreate
 */
export interface StationaryUnitZoneViolationEventCreate {
    /**
     * Unique ID for this event.
     * 
     * The ID is specified by the client to allow for indempotent submission of offline events. See the "Offline Synchronization" page in our documentation.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    id: string;
    /**
     * Time at which the device recorded the event.
     * @type {Date}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    time: Date;
    /**
     * Vehicle that triggered this event.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    vehicleId: string;
    /**
     * Stationary unit that triggered this event.
     * 
     * This is set to the network ID of the stationary unit's antenna B if the zone violation event was triggered by the ELObox's antenna A.
     * 
     * One of `stationary_unit_antenna_b_network_id` and `stationary_unit_machine_id` must be set, but not both.
     * @type {number}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    stationaryUnitAntennaBNetworkId?: number | null;
    /**
     * Stationary unit that triggered this event.
     * 
     * This is set to the stationary unit's machine ID if the zone violation event was triggered by the ELObox's antenna B.
     * 
     * One of `stationary_unit_antenna_b_network_id` and `stationary_unit_machine_id` must be set, but not both.
     * @type {number}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    stationaryUnitMachineId?: number | null;
    /**
     * User that was logged in at the time the event occurred.
     * @type {string}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    userId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    minimumDistanceCm: number;
    /**
     * ELOshield Zone which was violated
     * @type {ProximityZone}
     * @memberof StationaryUnitZoneViolationEventCreate
     */
    triggeredZone: ProximityZone;
}



/**
 * Check if a given object implements the StationaryUnitZoneViolationEventCreate interface.
 */
export function instanceOfStationaryUnitZoneViolationEventCreate(value: object): value is StationaryUnitZoneViolationEventCreate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('minimumDistanceCm' in value) || value['minimumDistanceCm'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    return true;
}

export function StationaryUnitZoneViolationEventCreateFromJSON(json: any): StationaryUnitZoneViolationEventCreate {
    return StationaryUnitZoneViolationEventCreateFromJSONTyped(json, false);
}

export function StationaryUnitZoneViolationEventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationaryUnitZoneViolationEventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'time': (new Date(json['time'])),
        'vehicleId': json['vehicleId'],
        'stationaryUnitAntennaBNetworkId': json['stationaryUnitAntennaBNetworkId'] == null ? undefined : json['stationaryUnitAntennaBNetworkId'],
        'stationaryUnitMachineId': json['stationaryUnitMachineId'] == null ? undefined : json['stationaryUnitMachineId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'minimumDistanceCm': json['minimumDistanceCm'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
    };
}

export function StationaryUnitZoneViolationEventCreateToJSON(json: any): StationaryUnitZoneViolationEventCreate {
    return StationaryUnitZoneViolationEventCreateToJSONTyped(json, false);
}

export function StationaryUnitZoneViolationEventCreateToJSONTyped(value?: StationaryUnitZoneViolationEventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'time': value['time'].toISOString(),
        'vehicleId': value['vehicleId'],
        'stationaryUnitAntennaBNetworkId': value['stationaryUnitAntennaBNetworkId'],
        'stationaryUnitMachineId': value['stationaryUnitMachineId'],
        'userId': value['userId'],
        'minimumDistanceCm': value['minimumDistanceCm'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
    };
}

